import { render, staticRenderFns } from "./AccountabilityReport.vue?vue&type=template&id=346f885c&"
import script from "./AccountabilityReport.vue?vue&type=script&lang=ts&"
export * from "./AccountabilityReport.vue?vue&type=script&lang=ts&"
import style0 from "./AccountabilityReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports